import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { PriceConverter } from '../../../../helpers'
import styles from './SingleOccupancyCard.module.scss'

PriceSection.propTypes = {
  occupancy: PropTypes.object,
  currency: PropTypes.string,
  product: PropTypes.object.isRequired,
  isApplySingle: PropTypes.bool,
  isUpgraded: PropTypes.bool,
}

export default function PriceSection({
  occupancy,
  currency,
  product,
  isApplySingle,
  isUpgraded,
}) {
  const price = {
    current: isApplySingle ? product.items[0].priceNet : occupancy?.priceNet,
    modified: isApplySingle ? occupancy?.priceNet : product.items[0].priceNet,
  }
  return (
    <div className={styles.priceBlock}>
      {isUpgraded ? (
        <FormattedMessage id='your_saving' defaultMessage='Your saving:' />
      ) : (
        <FormattedMessage id='additional_price' defaultMessage='Additional price:' />
      )}
      &nbsp;
      <span className={styles.newPrice}>
        <PriceConverter amount={price.current} currency={currency} />
      </span>
      <span className={styles.oldPrice}>
        (<FormattedMessage id='instead_of' defaultMessage='instead of' />
        &nbsp;
        <PriceConverter amount={price.modified} currency={currency} />)
      </span>
    </div>
  )
}
